import { defineMessages } from 'react-intl';

export default defineMessages({
  closeModal: {
    id: 'Pdp.flatRateProductBlock.closeModal',
    description: 'Close modal button aria-label',
    defaultMessage: 'Close modal',
  },
  addedToCart: {
    id: 'Pdp.flatRateProductBlock.addedToCart',
    description: 'added to cart label',
    defaultMessage: 'Added to Cart',
  },
});
